import { useState, useRef, useEffect, useMemo } from "react";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import moment from "moment";
import { EventoService } from "../../../services/EventoService";
import { FormUtility } from "../../Utility/FormUtility";

export default function EmailAudit() {
    const eventoService = new EventoService();
    const utility = new FormUtility();
    const dtRef = useRef();


    const dtOptions = useMemo(() => {
        return {
        columns: [
                {
                    name: "Id",
                    data: "id",
                    visible: true,
                    sortable: false,
                    searchable: false,
                },
                {
                    name: "Azione",
                    data: "azione",
                    visible: true,
                    sortable: false,
                    searchable: true
                },
                {
                    name: "Codice domanda",
                    data: "oggetto",
                    visible: true,
                    sortable: true,
                    searchable: true,
                    cell: (row, col) => {
                        return row.oggetto?.richiesta?.codice?? row.oggetto?.codiceDomanda;
                    }
                },
                {
                    name: "C.F Utente",
                    data: "codiceFiscale",
                    visible: true,
                    sortable: true,
                    searchable: true
                },
                {
                    name: "Data evento",
                    data: "createdAt",
                    visible: true,
                    sortable: true,
                    searchable: true,
                    cell: (row, col) => {
                        return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
                    }
                },
                {
                    name: "Oggetto",
                    data: "",
                    visible: true,
                    sortable: false,
                    searchable: true,
                    cell: (row, col) => {
                        return utility.getValueFromObj(row.oggetto, "soggetto");
                    }
                }/* ,
                {
                    name: "Esito",
                    data: "",
                    visible: true,
                    sortable: false,
                    searchable: true,
                    cell: (row, col) => {
                        return row.azione === "SALVATAGGIO_EMAIL"? "OK" : "KO";
                    }
                } */
            ],
            serverSide: true,
            rows: [],
            sorts: [],
            hideSearch: false,
            title: "Elenco eventi Email",
            ajax: eventoService.getAllDt,
            ajaxParams: {
                entity: ["Email"],
                searchableItem: [
                    "codice",
                    "soggetto"
                ]
            },
        };
    }, []);

    return (
        <DataTableWrapper
            ref={dtRef}
            dtOptions={dtOptions}
        />
    );
}